import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: var(--border-radius);
  padding: 15px 20px;
  margin: 15px auto;
  color: var(--text-light);
  backdrop-filter: blur(4px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
  width: 100%;
  max-width: 800px;
  z-index: 100;
  position: relative;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const ErrorContent = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const ErrorIcon = styled.div`
  color: #ef4444;
  font-size: 20px;
  margin-right: 15px;
  flex-shrink: 0;
`;

const ErrorMessage = styled.div`
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 16px;
  cursor: pointer;
  margin-left: 15px;
  transition: color 0.2s;
  
  &:hover {
    color: var(--text-light);
  }
`;

const ErrorNotification = ({ message, onClose }) => {
  return (
    <ErrorContainer>
      <ErrorContent>
        <ErrorIcon>
          <FontAwesomeIcon icon={faExclamationCircle} />
        </ErrorIcon>
        <ErrorMessage>{message}</ErrorMessage>
      </ErrorContent>
      {onClose && (
        <CloseButton onClick={onClose} aria-label="Close error message">
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      )}
    </ErrorContainer>
  );
};

export default ErrorNotification; 